<sm-navigation
[style.--active-menu-text-color]="activeMenuTextColor"
[style.--expanded-menu-items-border]="expandedMenuItemsBorder"
  [items]="navigationItems$ | async"
  [activeUrl]="activeUrl$ | async"></sm-navigation>
